import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/message_bg.gif';
import _imports_1 from '@assets/images/avatar1.jpg';

const _withScopeId = n => (_pushScopeId("data-v-6c3e7245"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "header"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconcamera",
  style: {
    "font-size": "20px"
  }
}, null, -1));

const _hoisted_4 = [_hoisted_3];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  srcset: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "zhanzhan.wei")])], -1));

const _hoisted_6 = {
  class: "messages"
};
const _hoisted_7 = {
  class: "message-item-box"
};
const _hoisted_8 = {
  class: "user"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = {
  class: "msg-container"
};
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "texts"
};
const _hoisted_14 = {
  key: 0,
  class: "imgs"
};
const _hoisted_15 = ["src", "onClick"];
const _hoisted_16 = {
  class: "desc"
};
const _hoisted_17 = {
  class: "popover-action"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 赞 ");

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "|", -1));

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 评论 ");

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "support"
}, [/*#__PURE__*/_createElementVNode("span", null, "· ·")], -1));

const _hoisted_22 = {
  key: 0,
  class: "stars"
};
const _hoisted_23 = {
  class: "star-icon"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "star-item"
}, " zhanzhan.wei ", -1));

const _hoisted_25 = {
  key: 1,
  class: "comments"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "comment-item"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "comment-user"
}, "zhanzhan.wei:"), /*#__PURE__*/_createTextVNode(" 欢迎大家,有想法和建议随时找我联系，可留言可加V ")], -1));

const _hoisted_27 = [_hoisted_26];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_popover = _resolveComponent("van-popover");

  const _component_van_list = _resolveComponent("van-list");

  const _component_app_container = _resolveComponent("app-container");

  return _openBlock(), _createBlock(_component_app_container, {
    appbar: false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
      class: "action fl",
      onClick: _cache[0] || (_cache[0] = //@ts-ignore
      (...args) => _ctx.toBack && _ctx.toBack(...args))
    }, [_createVNode(_component_van_icon, {
      name: "arrow-left",
      size: "20"
    })]), _createElementVNode("div", {
      class: "action fr",
      onClick: _cache[1] || (_cache[1] = //@ts-ignore
      (...args) => _ctx.toSendMessage && _ctx.toSendMessage(...args))
    }, _hoisted_4), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[4] || (_cache[4] = $event => _ctx.loading = $event),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.objectId,
          class: "message-item"
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          id: item.objectId,
          class: "identicon"
        }, _toDisplayString(_ctx.setAvatar(item.objectId)), 9, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.content), 1), item.files && item.files.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.files, (img, index) => {
          return _openBlock(), _createElementBlock(_Fragment, null, [img ? (_openBlock(), _createElementBlock("img", {
            key: img,
            src: img,
            alt: "",
            srcset: "",
            onClick: $event => _ctx.showImg(item.files, {
              startPosition: index
            })
          }, null, 8, _hoisted_15)) : _createCommentVNode("", true)], 64);
        }), 256))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(item.name === "zhanzhan.wei" ? "最新" : _ctx.getBeforeNowCount(item.createdAt)), 1), _createElementVNode("div", null, [_createVNode(_component_van_popover, {
          show: item.state,
          "onUpdate:show": $event => item.state = $event,
          placement: "left"
        }, {
          reference: _withCtx(() => [_hoisted_21]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
            class: "star",
            onClick: _cache[2] || (_cache[2] = //@ts-ignore
            (...args) => _ctx.toStar && _ctx.toStar(...args))
          }, [_createVNode(_component_van_icon, {
            name: "like-o"
          }), _hoisted_18]), _hoisted_19, _createElementVNode("div", {
            class: "comment",
            onClick: _cache[3] || (_cache[3] = //@ts-ignore
            (...args) => _ctx.toComment && _ctx.toComment(...args))
          }, [_createVNode(_component_van_icon, {
            name: "smile-comment-o",
            size: "16px"
          }), _hoisted_20])])]),
          _: 2
        }, 1032, ["show", "onUpdate:show"])])]), item.name === 'zhanzhan.wei' ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, [_createVNode(_component_van_icon, {
          name: "like-o",
          size: "12"
        })]), _hoisted_24])) : _createCommentVNode("", true), item.name === 'zhanzhan.wei' ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27)) : _createCommentVNode("", true)])])]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])])]),
    _: 1
  });
}